// ─────────────────────────────────────────────
// TRULIGON Page JavaScript
// ─────────────────────────────────────────────

// Set current year in footer
const yearElement = document.getElementById('year');
if (yearElement) {
    yearElement.textContent = new Date().getFullYear().toString();
}

// Smooth scrolling for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (this: HTMLAnchorElement, e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href') || '');
        if (target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    });
});

// Initialize any TRULIGON-specific functionality
// - Intersection Observer for section animations
// - CTA tracking
// - Form handling if needed

document.addEventListener('DOMContentLoaded', () => {
    // Initialize smooth scroll for all internal links
    initSmoothScroll();

    // Add scroll reveal observations if needed
    initScrollReveal();

    // CTA click tracking
    initCTATracking();
});

function initSmoothScroll(): void {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            if (targetId && targetId !== '#') {
                const targetElement = document.querySelector(targetId);
                if (targetElement) {
                    targetElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }
        });
    });
}

function initScrollReveal(): void {
    // Observe sections as they enter viewport
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);

    // Observe all sections
    document.querySelectorAll('.section').forEach(section => {
        section.style.opacity = '0';
        section.style.transform = 'translateY(20px)';
        section.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(section);
    });
}

function initCTATracking(): void {
    // Track CTA clicks for analytics
    const ctas = document.querySelectorAll('.cta:not([href="#"])');
    ctas.forEach(cta => {
        cta.addEventListener('click', (e) => {
            // Could send analytics event here
            console.log('CTA clicked:', cta.textContent || cta.getAttribute('href'));
        });
    });
}
